const GridBase = (props) => {
  const { children } = props;

  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-4 xl:gap-6">
      {children}
    </div>
  );
};

export default GridBase;
